import { render, staticRenderFns } from "./SquareOption.vue?vue&type=template&id=0b3bb58e&"
import script from "./SquareOption.vue?vue&type=script&lang=js&"
export * from "./SquareOption.vue?vue&type=script&lang=js&"
import style0 from "./SquareOption.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\DevOpsAgent\\agent1\\_work\\10\\s\\Site\\Source\\Web\\Marketing.UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b3bb58e')) {
      api.createRecord('0b3bb58e', component.options)
    } else {
      api.reload('0b3bb58e', component.options)
    }
    module.hot.accept("./SquareOption.vue?vue&type=template&id=0b3bb58e&", function () {
      api.rerender('0b3bb58e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Views/Marketing/ProForm/components/shared/SquareOption.vue"
export default component.exports